import { type ProcessMediaMutation } from "../api/mutation/processMedia.gql-generated";

export const convertToFile = (data: ProcessMediaMutation): File | undefined => {
    const base64Data = data.processMedia.mediaUrl.split(",")[1]; // Extract base64 part
    if (!base64Data) {
        return undefined;
    }

    const byteCharacters = atob(base64Data); // Decode base64 string
    const byteNumbers: number[] = Array.from({ length: byteCharacters.length });
    for (let i = 0; i < byteCharacters.length; i++) {
        const codePoint = byteCharacters.codePointAt(i);
        if (codePoint !== undefined) {
            byteNumbers[i] = codePoint;
        }
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.processMedia.mediaType });
    const file = new File([blob], data.processMedia.mediaId, { type: data.processMedia.mediaType });

    return file;
};
